import { DefaultTheme } from 'styled-components';

import { defaultContainerStyles } from 'app/components/container/default-container-styles';
import { defaultParagraphPlaceholderStyles } from 'app/components/paragraph-placeholder/default-paragraph-placeholder-styles';

export const theme: DefaultTheme = {
    container: defaultContainerStyles,
    paragraphPlaceholder: defaultParagraphPlaceholderStyles,
};
